export type CreateRoomOut = {
  code: string;
  livekit_room: string;
  owner_url: string;
  guest_url: string;
};

export type IceServer = {
  urls: string[];
  username?: string | null;
  credential?: string | null;
};

export type JoinOut = {
  room_code: string;
  livekit_room: string;
  ws_url: string;
  token: string;
  identity: string;
  display_name: string;
  ice_servers?: IceServer[];
};

// Same-origin — nginx on video-app rewrites /api -> backend :8020.
const BASE = "";

export async function createRoom(): Promise<CreateRoomOut> {
  const res = await fetch(`${BASE}/api/rooms`, { method: "POST" });
  if (!res.ok) throw new Error(`createRoom failed: ${res.status}`);
  return res.json();
}

export async function joinRoom(
  code: string,
  name: string,
  role: "owner" | "guest",
): Promise<JoinOut> {
  const u = new URL(`${BASE}/api/rooms/${encodeURIComponent(code)}/join`, window.location.origin);
  u.searchParams.set("name", name);
  u.searchParams.set("role", role);
  const res = await fetch(u.toString());
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`joinRoom ${res.status}: ${body}`);
  }
  return res.json();
}
